import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { useTheme } from '@mui/material/styles';
import { Theme as AugmentedTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { Icon, Typography } from 'web-library';
import { candidateService } from '../../../api';
import { stringToLongDateAndShortTime } from '../../../utils/DateUtils';

const useStyles = makeStyles()((theme) =>
({
  root: {
    display: 'flex',
    marginTop: theme.spacing(3),
  },
  root2: {
    display: 'flex',
    marginTop: theme.spacing(1),
  },
  draftIcon: {
    display: 'flex',
    alignItems: 'center',
  },
  draftMessage: {
    fontWeight: 700,
    color: theme.color.text.textTertiary,
    marginLeft: theme.spacing(1),
  },
}));

interface DraftMessageProps {
  enableApi?: boolean;
}

const DraftMessage = ({ enableApi = true }: DraftMessageProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles();
  const [draftMessage, setDraftMessage] = useState<string>('');

  // @ts-ignore
  const { uuid: requestUuid } = useParams();

  const { data } = candidateService.specialConsideration.candidate.useDraftSavedDateTime(
    requestUuid,
    {
      enabled: enableApi,
    }
  );

  useEffect(() => {
    if (requestUuid && data) {
      setDraftMessage(data.draftSavedDateTime);
    }
  }, [data, requestUuid, t]);

  return (
    <>
      {draftMessage && (
        <div className={classes.root}>
          <div className={classes.draftIcon}>
            <Icon
              className={classes.draftIcon}
              name={IconName.clock}
              size="M"
              color={theme.color.icon.iconDefault}
            />
          </div>

          <Typography className={classes.draftMessage}>
            {t('components->>DraftTimeStamp.Saved')}
            {stringToLongDateAndShortTime(draftMessage)}
          </Typography>
        </div>
      )}
        <div className={classes.root2}>
          <div className={classes.draftIcon}>
            <Icon
              className={classes.draftIcon}
              name={IconName.info}
              size="M"
              color={theme.color.icon.iconTrash}
            />
          </div>

            <Typography className={classes.draftMessage} style={{color: theme.color.icon.iconTrash}} >
              {t('components->>ApplicationReminderMessage.SCReminderText')}
            </Typography>
          </div>
    </>
  );
};
export default DraftMessage;
